import { type FC } from 'react';
import { useMapIdSelector } from '~/store/selectors/useMapIdSelector';
import { MapPageContainer } from '../page/mapPage.container';
import { useIsMapFullyInitialized } from './useIsMapFullyInitialized';

export const MapPresentationalContainer: FC = () => {
  useIsMapFullyInitialized();
  const mapId = useMapIdSelector();

  return (<MapPageContainer mapId={mapId} />);
};
